import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
export function Footer() {
  const form = useRef<HTMLFormElement>(null);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const handleMiniForm = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.current) return;
    setSending(true);
    emailjs.sendForm('service_doctorecommerce', 'template_roofing_lead', form.current, 'YOUR_PUBLIC_KEY').then(() => {
      setSending(false);
      setSent(true);
      form.current?.reset();
    }).catch(() => {
      setSending(false);
    });
  };
  const scrollTo = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (id === 'top') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#050505] border-t border-[#1A1A1A]" data-id="element-173">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16" data-id="element-174">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8" data-id="element-175">
          {/* Column 1 — Brand */}
          <div data-id="element-176">
            <img src="https://cdn.magicpatterns.com/uploads/qzNqs1iSkCkxLjQLXd7JhF/IMG_6635.jpg" alt="Doctor Ecommerce Logo" className="w-[140px] mb-5" data-id="element-177" />
            <p className="text-gold font-heading font-bold text-lg italic mb-4" data-id="element-178">
              La cura para negocios estancados.
            </p>
            <p className="text-gray-sec text-sm leading-relaxed mb-6" data-id="element-179">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Servimos a dueños de negocios de
              Roofing en todo Estados Unidos, transformando presupuestos
              publicitarios en máquinas de generación de llamadas y ventas
              diarias.
            </p>
            {/* Social Icons */}
            <div className="flex gap-4" data-id="element-180">
              <a href="https://instagram.com/doctorecommerce" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold transition-colors" aria-label="Instagram" data-id="element-181">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-182">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-183" />
                </svg>
              </a>
              <a href="https://facebook.com/doctorecommerce" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold transition-colors" aria-label="Facebook" data-id="element-184">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-185">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-186" />
                </svg>
              </a>
              <a href="https://linkedin.com/company/doctorecommerce" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold transition-colors" aria-label="LinkedIn" data-id="element-187">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-188">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-189" />
                </svg>
              </a>
              <a href="https://tiktok.com/@doctorecommerce" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold transition-colors" aria-label="TikTok" data-id="element-190">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-191">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-192" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2 — Servicios */}
          <div data-id="element-193">
            <h3 className="text-gold font-heading font-bold text-sm tracking-widest uppercase mb-6" data-id="element-194">
              Servicios
            </h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-195">
              <li data-id="element-196">Meta Ads · Google Ads · TikTok Ads · YouTube Ads</li>
              <li data-id="element-197">Email · SMS · Retargeting Automatizado</li>
              <li data-id="element-198">Automatización con IA para Ventas 24/7</li>
              <li data-id="element-199">Funnels Quirúrgicos por Industria</li>
              <li data-id="element-200">Blindaje Digital & Anti-Ban</li>
              <li data-id="element-201">PR Digital & Posicionamiento en Medios</li>
              <li data-id="element-202">CRM & Data Tracking Avanzado</li>
              <li data-id="element-203">Video Marketing IA · SEO · Branding</li>
              <li data-id="element-204">Gestión de Reputación · Google Maps</li>
              <li data-id="element-205">Diseño Web · Landing Pages · CRO</li>
            </ul>
          </div>

          {/* Column 3 — Recursos */}
          <div data-id="element-206">
            <h3 className="text-gold font-heading font-bold text-sm tracking-widest uppercase mb-6" data-id="element-207">
              Recursos
            </h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-208">
              <li data-id="element-209">
                <a href="#" onClick={scrollTo('top')} className="hover:text-white transition-colors flex items-center gap-2" data-id="element-210">
                  <span className="text-gold text-xs" data-id="element-211">›</span> Blog de
                  Estrategia
                </a>
              </li>
              <li data-id="element-212">
                <a href="#" onClick={scrollTo('resultados')} className="hover:text-white transition-colors flex items-center gap-2" data-id="element-213">
                  <span className="text-gold text-xs" data-id="element-214">›</span> Casos de Éxito
                </a>
              </li>
              <li data-id="element-215">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-216">
                  <span className="text-gold text-xs" data-id="element-217">›</span> Política de
                  Privacidad
                </a>
              </li>
              <li data-id="element-218">
                <a href="#" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-219">
                  <span className="text-gold text-xs" data-id="element-220">›</span> Términos y
                  Condiciones
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 — Contacto Directo */}
          <div data-id="element-221">
            <h3 className="text-gold font-heading font-bold text-sm tracking-widest uppercase mb-6" data-id="element-222">
              Contacto Directo
            </h3>
            <ul className="space-y-4 text-sm mb-6" data-id="element-223">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-224">
                <svg className="w-4 h-4 text-gold mt-0.5 shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-225">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-226" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-227" />
                </svg>
                1001 WATER ST, TAMPA FL 33602
              </li>
              <li className="flex items-center gap-3" data-id="element-228">
                <svg className="w-4 h-4 text-gold shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-229">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" data-id="element-230" />
                </svg>
                <a href="tel:4028720639" className="text-gray-400 hover:text-white transition-colors" data-id="element-231">
                  (402) 872-0639
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-232">
                <svg className="w-4 h-4 text-gold shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-233">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-234" />
                </svg>
                <a href="mailto:doctor.ecommerceus@gmail.com" className="text-gray-400 hover:text-white transition-colors" data-id="element-235">
                  doctor.ecommerceus@gmail.com
                </a>
              </li>
            </ul>

            {/* WhatsApp Button */}
            <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-emerald text-white font-bold rounded-lg px-4 py-3 mb-3 hover:brightness-110 transition-all text-sm" data-id="element-236">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-237">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-238" />
              </svg>
              Habla con un Especialista
            </a>

            {/* Calendar Button */}
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full border border-gold text-gold font-bold rounded-lg px-4 py-3 hover:bg-gold/10 transition-all text-sm" data-id="element-239">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-240">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-241" />
                <line x1="16" y1="2" x2="16" y2="6" data-id="element-242" />
                <line x1="8" y1="2" x2="8" y2="6" data-id="element-243" />
                <line x1="3" y1="10" x2="21" y2="10" data-id="element-244" />
              </svg>
              RESERVAR DIAGNÓSTICO
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1A1A1A]" data-id="element-245">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-8" data-id="element-246">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8" data-id="element-247">
            {/* Partners */}
            <div data-id="element-248">
              <p className="text-gray-500 text-xs tracking-widest uppercase mb-4 font-bold" data-id="element-249">
                Partners Certificados y Tecnología de Élite
              </p>
              <div className="flex gap-3 items-center" data-id="element-250">
                <div className="bg-[#111] border border-[#1A1A1A] rounded-md px-3 py-2 text-xs text-gray-400 font-medium" data-id="element-251">
                  Meta Partner
                </div>
                <div className="bg-[#111] border border-[#1A1A1A] rounded-md px-3 py-2 text-xs text-gray-400 font-medium" data-id="element-252">
                  Google Ads
                </div>
                <div className="bg-[#111] border border-[#1A1A1A] rounded-md px-3 py-2 text-xs text-gray-400 font-medium" data-id="element-253">
                  Certified
                </div>
                <div className="bg-[#111] border border-[#1A1A1A] rounded-md px-3 py-2 text-xs text-gray-400 font-medium hidden md:block" data-id="element-254">
                  Shopify
                </div>
              </div>
            </div>

            {/* Mini Contact Form */}
            <div data-id="element-255">
              <p className="text-gray-500 text-xs tracking-widest uppercase mb-4 font-bold" data-id="element-256">
                ¿Quieres que te contactemos?
              </p>
              {sent ? <p className="text-emerald text-sm font-medium" data-id="element-257">
                  ¡Enviado! Te contactaremos pronto.
                </p> : <form ref={form} onSubmit={handleMiniForm} className="flex flex-col md:flex-row gap-3" data-id="element-258">
                  <input type="text" name="user_name" placeholder="Tu Nombre" required className="bg-[#0A0A0A] border border-[#1A1A1A] text-white placeholder-gray-600 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-gold/50 w-full md:w-auto" data-id="element-259" />
                  <input type="email" name="user_email" placeholder="Tu Email" required className="bg-[#0A0A0A] border border-[#1A1A1A] text-white placeholder-gray-600 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-gold/50 w-full md:w-auto" data-id="element-260" />
                  <input type="tel" name="user_phone" placeholder="Tu Teléfono" required className="bg-[#0A0A0A] border border-[#1A1A1A] text-white placeholder-gray-600 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-gold/50 w-full md:w-auto" data-id="element-261" />
                  <input type="text" name="company_name" placeholder="Nombre de tu Empresa" className="bg-[#0A0A0A] border border-[#1A1A1A] text-white placeholder-gray-600 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:border-gold/50 w-full md:w-auto" data-id="element-262" />
                  <button type="submit" disabled={sending} className="bg-gold text-carbon font-bold rounded-lg px-6 py-2.5 text-sm hover:brightness-110 transition-all tracking-wide disabled:opacity-70 shrink-0" data-id="element-263">
                    {sending ? '...' : 'ENVIAR'}
                  </button>
                </form>}
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 pt-6 border-t border-[#1A1A1A] text-center" data-id="element-264">
            <p className="text-xs text-gray-600" data-id="element-265">
              © {new Date().getFullYear()} Doctor Ecommerce. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}